

export default {
  listShopFilterSearch: [],
  listRegionsDO: [],
  totalRegionDO : 1,
  currentPage : 1,
  per_page : 10,
  priceMatrix: 0
}



// WEBPACK FOOTER //
// ./src/store/merchants/state.js